import frBookMap from '../assets/bible/fr/book_map.json';
import enBookMap from '../assets/bible/en/book_map.json';
import elBookMap from '../assets/bible/el/book_map.json';

// Maps from input text to standard book acronyms
const bookMapsByLocale: {[key: string]: {[key: string]: string}} = {
  fr: frBookMap,
  en: enBookMap,
  el: elBookMap,
};

/**
 * Normalize a string by removing diacritics (accents)
 * This helps with matching book names like "Genèse" -> "Genese"
 */
export function removeDiacritics(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Normalize a book name for comparison by:
 * 1. Converting to lowercase
 * 2. Removing diacritics
 * 3. Trimming spaces
 * 4. Removing punctuation
 */
export function normalizeBookNameForComparison(bookName: string): string {
  if (!bookName) return '';
  
  return removeDiacritics(bookName)
    .toLowerCase()
    .trim()
    .replace(/[.,;:'"!?]/g, '');
}

/**
 * Normalize a book name/input to a standard acronym
 * @param input The book name or partial text to normalize
 * @param locale The locale to use for input normalization
 * @returns The standardized book acronym
 */
export function normalizeBookToAcronym(input: string, locale: string = 'en'): string {
  const cleanInput = normalizeBookNameForComparison(input);
  
  // Get the appropriate map for the locale
  const bookMap = bookMapsByLocale[locale] || bookMapsByLocale.en;
  
  // Check if the input matches a key in the map
  if (bookMap[cleanInput]) {
    return bookMap[cleanInput];
  }
  
  // If not found in the map, return the original input for fallback processing
  return cleanInput;
}

/**
 * Get API-compatible book code
 */
export function getApiBookCode(bookAcronym: string): string {
  // For this implementation, we're assuming the API uses the same acronym system
  return bookAcronym;
}

export default {
  normalizeBookToAcronym,
  getApiBookCode
};
